import React from "react";
import { Layout } from "antd";
import { CommercialObligationSettings } from "./CommercialObligationSettings";
import { CommercialSettingRightContent } from "./CommercialSettingRightContent";
const { Content, Sider } = Layout;
export const CommercialObligationsBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={400}
            style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <CommercialObligationSettings />
                </div>
              </div>
            </div>
          </Sider>
          <Content>
            <CommercialSettingRightContent />
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

